import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSongodaComponent } from './simple-icons-songoda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSongodaComponent ],
    exports:      [ SimpleIconsSongodaComponent ],
    bootstrap:    []
})
export class SimpleIconsSongodaModule {}
